module.exports = __webpack_public_path__ + "img/case8.eacb3079.svg";